"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../../../../Flex"));

var _Text = _interopRequireDefault(require("../../../../../Text"));

var _Cycle = _interopRequireDefault(require("./Cycle"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _useIsLoading = _interopRequireDefault(require("../../../../LoadingProvider/useIsLoading"));

var _useTranslation = _interopRequireDefault(require("../../../../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Hours = function Hours(props) {
  var _props$hours = props.hours,
      hours = _props$hours === void 0 ? [] : _props$hours,
      other = (0, _objectWithoutProperties2["default"])(props, ["hours"]);
  var t = (0, _useTranslation["default"])();
  var isLoading = (0, _useIsLoading["default"])();

  if (!(hours === null || hours === void 0 ? void 0 : hours.length) && !isLoading) {
    return (0, _core.jsx)(_Flex["default"], other, (0, _core.jsx)(_Text["default"], null, t('rest')));
  }

  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    margin: [-1, -2]
  }, other), isLoading ? (0, _core.jsx)(_Loading["default"], {
    margin: [1, 2]
  }) : hours.map(function (cycle, index) {
    return (0, _core.jsx)(_Cycle["default"], {
      key: index,
      margin: [1, 2],
      start: cycle === null || cycle === void 0 ? void 0 : cycle.start,
      end: cycle === null || cycle === void 0 ? void 0 : cycle.end
    });
  }));
};

__signature__(Hours, "useTranslation{t}\nuseIsLoading{isLoading}", function () {
  return [_useTranslation["default"], _useIsLoading["default"]];
});

var _default = Hours;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Hours, "Hours", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();